/** @format */

import {Button, ModalHeader, Modal, Icon} from '@sttark/design-system';
import {handleChange, InputWithErrorHandler} from 'frontier-form';
import withDiscountHandler from './with_discount_handler';
import React, {useContext, useEffect, useState} from 'react';
import NumberFormat from 'react-number-format';
import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';

const Form = props => {
    return (
        <>
            <div className="mb-5">
                <InputWithErrorHandler
                    onChange={props.onInputChange.bind(this, 'discount_code')}
                    className="form-control form-control-sm"
                    value={props.discount_code || ''}
                    errorPath={'discount_id'}
                    error={props.error}
                    label="Enter code"
                    newestds
                />
            </div>
            <div>
                <div className="w-100 d-flex align-items-center justify-content-end">
                    <Button
                        label={props.pending ? 'Checking your code...' : 'Check Code'}
                        onClick={props.onCheckCode}
                        disabled={props.pending}
                    />
                </div>
            </div>
        </>
    );
};

export const DiscountForm = withDiscountHandler(
    handleChange(props => {
        const [showDiscountForm, setShowDiscountForm] = useState(false);
        const ctx = useContext(CartCheckoutContext);

        useEffect(() => {
            if (props.done) setShowDiscountForm(false);
        }, [props.done]);

        const handleEditDiscount = () => {
            props.onClearDiscountId();
            setShowDiscountForm(true);
        };
        return (
            <div>
                {/* discount form */}
                <Modal
                    isOpen={!!showDiscountForm}
                    onClose={() => setShowDiscountForm(false)}
                    bodyHeightAuto>
                    <ModalHeader onClose={() => setShowDiscountForm(false)}>
                        Add Discount Code
                    </ModalHeader>
                    <Form
                        onInputChange={props.onInputChange}
                        onCheckCode={props.onCheckCode}
                        pending={props.pending}
                        discount_code={props.discount_code}
                        error={props.error}
                    />
                </Modal>
                {!ctx.cart.discount_id && (
                    <div className="discount-cta mb-2">
                        <button
                            className="color-action-primary"
                            onClick={() => setShowDiscountForm(true)}>
                            + Add Discount Code
                        </button>
                    </div>
                )}

                {ctx.cart.discount_id && (
                    <div className="discount-code d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center justify-content-start">
                            <span className="me-3 color-action-primary">
                                Discount {ctx.cart.discount_code} Applied
                            </span>
                            <button
                                className="me-3 d-flex align-items-start justify-content-start tw-pt-1"
                                onClick={handleEditDiscount}>
                                <Icon name="edit" color="#000000" small />
                            </button>
                            <button
                                className="d-flex align-items-start justify-content-start tw-pt-1"
                                onClick={props.onRemoveDiscountId}>
                                <Icon name="trash" color="#df3d33" small />
                            </button>
                        </div>
                        <div className="discount-total">
                            <NumberFormat
                                value={ctx.cart.discount_amount}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                displayType={'text'}
                                decimalScale={2}
                                prefix={'$-'}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    })
);
